// extracted by mini-css-extract-plugin
export default {"body":"DeleteModal_body__gvRnA","burnButton":"DeleteModal_burnButton__Crecb"};